import { Pipe, PipeTransform } from '@angular/core';
@Pipe({ name: 'ReplaceNewLinePipe' })
export class ReplaceNewLinePipe implements PipeTransform {
  transform(value: string): string {
    let str = value.replace(/\n/g, '<br/>');
    str = value.replace(/\t/g, '<br/>&nbsp;&nbsp;&nbsp;&nbsp;');
    return str;
  }
}
